// Simple language names map - replaces @cospired/i18n-iso-languages
// Only includes languages we actually use

export type LocaleCode = 'sk' | 'en' | 'cs'

export type LocalizedLanguageNames = Record<string, string>

// Language names in Slovak
const languageNamesSK: Record<string, string> = {
    sk: 'slovenčina',
    en: 'angličtina',
    cs: 'čeština',
    hu: 'maďarčina',
    pl: 'poľština',
    de: 'nemčina',
    fr: 'francúzština',
    it: 'taliančina',
    da: 'dánčina',
    nl: 'holandčina',
    hr: 'chorvátčina',
    ru: 'ruština',
    es: 'španielčina',
    zh: 'čínština',
    ja: 'japončina',
    uk: 'ukrajinčina',
    pt: 'portugalčina',
    ro: 'rumunčina',
    bg: 'bulharčina',
    sr: 'srbčina',
    sl: 'slovinčina',
    fi: 'fínčina',
    sv: 'švédčina',
    no: 'nórčina',
    el: 'gréčtina',
    tr: 'turečtina',
    ar: 'arabčina',
    he: 'hebrejčina',
    ko: 'kórejčina',
    vi: 'vietnamčina',
    th: 'thajčina',
    id: 'indonézština',
    ms: 'malajčina',
    hi: 'hindčina'
}

// Language names in English
const languageNamesEN: Record<string, string> = {
    sk: 'Slovak',
    en: 'English',
    cs: 'Czech',
    hu: 'Hungarian',
    pl: 'Polish',
    de: 'German',
    fr: 'French',
    it: 'Italian',
    da: 'Danish',
    nl: 'Dutch',
    hr: 'Croatian',
    ru: 'Russian',
    es: 'Spanish',
    zh: 'Chinese',
    ja: 'Japanese',
    uk: 'Ukrainian',
    pt: 'Portuguese',
    ro: 'Romanian',
    bg: 'Bulgarian',
    sr: 'Serbian',
    sl: 'Slovenian',
    fi: 'Finnish',
    sv: 'Swedish',
    no: 'Norwegian',
    el: 'Greek',
    tr: 'Turkish',
    ar: 'Arabic',
    he: 'Hebrew',
    ko: 'Korean',
    vi: 'Vietnamese',
    th: 'Thai',
    id: 'Indonesian',
    ms: 'Malay',
    hi: 'Hindi'
}

// Language names in Czech
const languageNamesCS: Record<string, string> = {
    sk: 'slovenština',
    en: 'angličtina',
    cs: 'čeština',
    hu: 'maďarština',
    pl: 'polština',
    de: 'němčina',
    fr: 'francouzština',
    it: 'italština',
    da: 'dánština',
    nl: 'holandština',
    hr: 'chorvatština',
    ru: 'ruština',
    es: 'španělština',
    zh: 'čínština',
    ja: 'japonština',
    uk: 'ukrajinština',
    pt: 'portugalština',
    ro: 'rumunština',
    bg: 'bulharština',
    sr: 'srbština',
    sl: 'slovinština',
    fi: 'finština',
    sv: 'švédština',
    no: 'norština',
    el: 'řečtina',
    tr: 'turečtina',
    ar: 'arabština',
    he: 'hebrejština',
    ko: 'korejština',
    vi: 'vietnamština',
    th: 'thajština',
    id: 'indonéština',
    ms: 'malajština',
    hi: 'hindština'
}

const allLanguageNames: Record<LocaleCode, Record<string, string>> = {
    sk: languageNamesSK,
    en: languageNamesEN,
    cs: languageNamesCS
}

const language = {
    langs(): LocaleCode[] {
        return ['sk', 'en', 'cs']
    },

    getNames(locale: LocaleCode): LocalizedLanguageNames {
        return allLanguageNames[locale] || languageNamesSK
    },

    getName(code: string, locale: LocaleCode): string | undefined {
        const names = allLanguageNames[locale] || languageNamesSK
        return names[code]
    },

    getAlpha2Code(name: string, locale: LocaleCode): string | undefined {
        const names = allLanguageNames[locale] || languageNamesSK
        const entry = Object.entries(names).find(([, langName]) => langName.toLowerCase() === name.toLowerCase())
        return entry?.[0]
    }
}

export default language
